import { render, staticRenderFns } from "./ChartsDemo.vue?vue&type=template&id=03fe5db3&scoped=true&"
import script from "./ChartsDemo.vue?vue&type=script&lang=js&"
export * from "./ChartsDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fe5db3",
  null
  
)

export default component.exports